import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NavbarService } from './navbar.service';
// import { CookieService } from 'ngx-cookie-service';
import {CookieService} from '../../data-worker/cookie.service';
import { Router, ActivatedRoute } from "@angular/router";
import Auth from '@aws-amplify/auth';
import { ThrowStmt } from '@angular/compiler';

interface myData {

	deveui: string;
    type: string;
	metric1Name: string;
	metric1Value: string;
	metric2Name: string;
	metric2Value: string;
	metric3Name: string;
	metric3Value: string;
	metric4Name: string;
	metric4Value: string;
	metric5Name: string;
	metric5Value: string;
	metric6Name: string;
	metric6Value: string;
	metric7Name: string;
	metric7Value: string;
	metric8Name: string;
	metric8Value: string;
	metric9Name: string;
	metric9Value: string;
}

interface siteData {
    siteDescription: string;
    deveui: myData[];
}

interface companyData {
    companyName: string;
    sites: siteData[];
}

@Component({
    selector: 'app-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.scss']
})

export class NavbarComponent {

    arr_roomName = [];
	arr_deveui = [];

	new_result = [];
    euc = [];
    eus = [];
    eusMain = [];
    usertype = "";
    clientUser = false;
	apiToken = "";
    location = "";
    metric1Name = "";
    metric1Value = "";
    metric3Name = "";
    metric3Value = "";
    metric8Name = "";
    metric8Value = "";
    metric9Value = "";
    weatherIcon:any;
    weatherAvailable = false;
	degreeDaysAvailable = false;

	ddValue="";
	ddType="";
	ddTypeFull=""

	public myVar: any;

    currentLang = 'en';
    toggleClass = 'ft-maximize';
    constructor(public translate: TranslateService,
        private _myData: NavbarService,
         private cookieService: CookieService,
         private route: ActivatedRoute,
         private router: Router) {
        const browserLang: string = translate.getBrowserLang();
        translate.use(browserLang.match(/en|es|pt|de/) ? browserLang : 'en');
    }

    ChangeLanguage(language: string) {
        this.translate.use(language);
    }

    ToggleClass() {
        if (this.toggleClass === 'ft-maximize') {
            this.toggleClass = 'ft-minimize';
        }
        else
            this.toggleClass = 'ft-maximize' 
    }

    faqs() {

        this.router.navigate(['/dashboard/faqs'], { relativeTo: this.route.parent });        
        
    }
    
    helpdesk() {
        this.router.navigate(['/dashboard/helpdesk'], { relativeTo: this.route.parent });        

    }

	goToDD(){
		this.router.navigate(['/dashboard/degreedays'],{ relativeTo: this.route.parent });
	}

	goToResources(){
		this.router.navigate(['/dashboard/resources'],{relativeTo: this.route.parent})
	}

	goToMyAccount(){
		this.router.navigate(['/dashboard/myaccount'],{relativeTo: this.route.parent})
	}

	goToSettings(){
		this.router.navigate(['/dashboard/settings'],{relativeTo: this.route.parent})
	}

      // On submit button click    
      logOut() {
        // debugger
        Auth.signOut().then(data => {
            ////console.log(data);
            this.cookieService.deleteAll();
            // this.cookieService.set( 'auth', null );
            // this.cookieService.set('appUsername', undefined);
            // this.cookieService.set('appUserServe', undefined);
            // this.cookieService.set('appUserDefaultSite', undefined);
            // this.cookieService.set('appUserCurrentSite', undefined);
            // this.router.navigate(['/pages/login'], { relativeTo: this.route.parent });        
           //console.log("Logged out",   this.cookieService.get('auth'));
        }).catch(err => {
           //console.log(err)
        });
        this.cookieService.deleteAll();
        this.router.navigate(['/pages/login'], { relativeTo: this.route.parent });        
       //console.log("Logged out",   this.cookieService.get('auth'))
            
   
    }

    ngOnInit() {
		const userCheck = Auth.currentAuthenticatedUser({bypassCache: false  // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
        }).then(user => {
        
            if (this.cookieService.get('appUsername') != '' || this.cookieService.get('appUsername') != undefined || this.cookieService.get('appUsername')){
                if (this.cookieService.get('appUsername') != user.username){                    
                    this.logOut();
                }
                // If authentication is ok then begin Init logic
                this.apiToken =user.signInUserSession.idToken.jwtToken;
                
                // Put init operations here

				this.usertype = this.cookieService.get('rulerGuide');
				////console.log("usertype", this.usertype)
				if (this.usertype == "1"){
					////console.log("usertype inside if");
					this.clientUser = true;
					let arr_dev = JSON.parse(this.cookieService.get("company_sites"));
					////console.log("company_sites", arr_dev);
					//let euc = [];
				let deveui = [];
				// array of companies
				for (let comp of arr_dev) {
					let companyname = Object.keys(comp)[0];
					let company = {} as companyData;
					let all_sites = [];
					// individual company
					for (let a of comp[companyname]){
					let site = {} as siteData;
					let dev_array = [];
					// individual site
					for (let dev of a.deveui){
						
						// deveui array
						if (dev[0] == "fuel"){
							deveui.push(dev[1]);
							dev_array.push(dev[1]);
							//console.log(dev);
						}
					}
					//  //console.log("dev_array above", dev_array);
					if(dev_array && dev_array.length > 0){
						site.siteDescription = a.description;
						site.deveui = dev_array;
					}
					//  //console.log("site above", site);
					if (site.deveui && site.deveui.length > 0){
						all_sites.push(site);
					}
					}
					if (all_sites && all_sites.length > 0){
						company.companyName = companyname;
						company.sites = all_sites;
						this.euc.push(company);
					}
				}
				////console.log("raw deveuis??", deveui);
				////console.log("new company array??", this.euc);
					
				this._myData.requestData(deveui, this.apiToken) 
				.subscribe(res => {
					//  //console.log(res);
					//console.log("header", res.headers);
					let array_a: myData[];
					array_a = res as myData[];
					//   let array_b = [];
					//   for(let x of array_a) array_b.push(x[0]);
					//console.log("new results ??", array_b);
			
					for(let i = 0; i < this.euc.length; i++){
						////console.log("company &&", this.euc[i]);
						//    //console.log("all sites &&", this.euc[i].sites);
							for(let k = 0; k < this.euc[i].sites.length; k++){
								////console.log("site &&", this.euc[i].sites[k]);
								////console.log("site name &&", this.euc[i].sites[k].siteDescription);
								////console.log("site deveui &&", this.euc[i].sites[k].deveui);
								let dd = [] as Array<myData>;
								for(let l = 0; l < this.euc[i].sites[k].deveui.length; l++){
									//console.log("deveui &&", euc[i][j][k][1][l]);
									for(let z of array_a){
										if (z[0].deveui == this.euc[i].sites[k].deveui[l]){
											dd.push(z[0]);
											//this.euc[i].sites[k].deveui[l] = z;
										}
									}
								}
								////console.log("this is dd??", dd);
								this.euc[i].sites[k].deveui = dd;
								
							}
					}
					////console.log("did we reach here");
					////console.log("new company results??", this.euc);
					
					
				});
			
				}
				else {
                    let own_sites = JSON.parse(this.cookieService.get("own_sites"));

					////console.log(own_sites)
					
					////console.log("location ??", own_sites[0].weatherID);
					if (own_sites[0].weatherID !== null && own_sites[0].weatherID !== '' && own_sites[0].weatherID !== undefined){
                        ////console.log("own_sites.weatherID: ", own_sites.weatherID);
                        this._myData.requestData([own_sites[0].weatherID], this.apiToken) 
                        .subscribe(res => {
                            ////console.log("navbar response: ", res);
							this.weatherAvailable = true;
                            let array_a: myData[]; ;
                            array_a = res as myData[];
                            this.metric1Name = array_a[0].metric1Name;
                            // this.metric1Value = array_a[0].metric1Value + ' @ ' + array_a[0].metric2Value;
                            this.metric1Value = array_a[0].metric1Value;
                            this.metric3Name = array_a[0].metric3Name;
                            this.metric3Value = array_a[0].metric3Value;
                            this.metric8Name = array_a[0].metric8Name;
                            this.metric8Value = array_a[0].metric8Value;
                            this.weatherIcon = "http://openweathermap.org/img/wn/"+array_a[0].metric9Value+".png" ;
                            ////console.log("final ??", this.metric1Name, this.metric1Value, this.metric3Name, this.metric3Value, this.metric8Name, this.metric8Value);  
                        });
						////console.log(own_sites[0])
						if (own_sites[0].degreeDays){
							this._myData.requestDegreeDays(own_sites[0].degreeDays,this.apiToken).subscribe(
								res => 
								{
									////console.log("degree days requesting"+ JSON.stringify(res))
									this.ddValue = res["dd"]
									this.ddType = res["ddType"]
									this.ddTypeFull = res["ddTypeFull"]
									this.degreeDaysAvailable = true;
								
								}
							)
						}
						
                    }
				}
				
			

				// Init operations end here
        
			}else{
				this.logOut();
			}
			// console.clear()

		
		}).catch(err => {
			////console.log(err);
			////console.log("AUTH is FALSE");
			// this.cookieService.deleteAll();
			this.logOut();
		}); 
		// console.clear()

	}

}



// WEBPACK FOOTER //
// ./src/app/shared/navbar/navbar.component.ts